module.exports = __webpack_public_path__ + "img/icon-room-garage.4ec1a7a1.svg";